export const updateEmployeeVolunteering = (employeeVolunteering) => {
	return {
		employeeVolunteering,
		type: 'UPDATE_EMPLOYEE_VOLUNTEERING'
	}
};